import React, { useRef } from 'react'

const FileUploader = ({ children, uploadFileHandler, fileID, accept }) => {
    const uploadImageRef = useRef()

    const onFileUpload = () => {
        uploadImageRef.current.click()
        uploadImageRef.current.value = null
    }

    return (
        <>
            {React.cloneElement(children, { onClick: onFileUpload })}
            <input
                ref={uploadImageRef}
                style={{ display: 'none' }}
                id={fileID}
                className={'input-file'}
                type="file"
                accept={accept}
                onChange={uploadFileHandler}
            />
        </>
    )
}

export default FileUploader
